import React from 'react';

interface SelfProps {
    currentStep: string,
    isOnLastStep: boolean,
    onPreviousStepButtonClick: any,
    onNextStepButtonClick: any,
    isPreviousButtonActive: boolean,
    isNextButtonActive: boolean,
}

export default class EditorNavigationButtons extends React.Component<SelfProps> {

    state = {
        isOverFooter: false,
        reScroll: false,
        pxOverFooter: 0
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onWindowScroll)
        this.onWindowScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onWindowScroll)
    }

    componentDidUpdate(prevProps: SelfProps) {
        if (this.props.currentStep !== prevProps.currentStep && !this.state.reScroll) {
            this.setState({
                reScroll: true
            }, () => {
                this.onWindowScroll();
            });
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps: SelfProps) {
        this.setState({
            pxOverFooter: 0
        })
    }

    onWindowScroll = () => {
        let scrolledY = window.scrollY + window.innerHeight
        let documentHeight = document.body.scrollHeight

        if (window.scrollY > 0 && scrolledY > documentHeight - 44) {
            this.setState({
                reScroll: false,
                isOverFooter: true,
                pxOverFooter: scrolledY - (documentHeight - 44),
                lastDocumentHeight: documentHeight
            })
        } else {
            this.setState({
                reScroll: false,
                isOverFooter: false,
                lastDocumentHeight: documentHeight
            })
        }
    }

    canRenderNextButton = () => {
        return !this.props.isOnLastStep;
    }

    onNextStepButtonClick = () => {
        if (this.props.isOnLastStep || !this.props.isNextButtonActive)
            return;

        this.props.onNextStepButtonClick();
    }

    render() {
        let styles = this.state.isOverFooter ? {bottom: this.state.pxOverFooter + 'px'} : {}
        let nextButtonClassNames = ['big-button-primary'];
        if (this.props.isOnLastStep || !this.props.isNextButtonActive) {
            nextButtonClassNames.push('disabled')
        }

        return (
            <React.Fragment>
                <div className="configuration-editor-navigation-buttons-filler"></div>
                <div className="configuration-editor-navigation-buttons" style={styles}>
                    <div className="page-container">
                        <div
                            className={this.props.isPreviousButtonActive ? 'big-button-primary' : 'big-button-secondary disabled'}
                            onClick={this.props.onPreviousStepButtonClick}>{window.__('Previous step')}</div>
                        {this.canRenderNextButton() && (
                            <React.Fragment>

                                <div className="issues-list-navigation-bar">

                                    <div className={nextButtonClassNames.join(' ')}
                                         onClick={this.onNextStepButtonClick}>
                                        <div className={"big-button-label"}>
                                            {window.__(this.props.isOnLastStep ? 'Save' : 'Continue')}
                                        </div>
                                        <div className="big-button-icon">
                                            <span>
                                                <span>
                                                    <svg width="14px" height="16px" viewBox="0 0 450 370">
                                                        <path d="M421.976,196.712L236.111,10.848C228.884,3.615,220.219,0,210.131,0c-9.9,0-18.464,3.615-25.697,10.848L163.023,32.26
                                                                c-7.234,6.853-10.85,15.418-10.85,25.697c0,10.277,3.616,18.842,10.85,25.697l83.653,83.937H45.677
                                                                c-9.895,0-17.937,3.568-24.123,10.707s-9.279,15.752-9.279,25.837v36.546c0,10.088,3.094,18.698,9.279,25.837
                                                                s14.228,10.704,24.123,10.704h200.995L163.02,360.88c-7.234,7.228-10.85,15.89-10.85,25.981c0,10.089,3.616,18.75,10.85,25.978
                                                                l21.411,21.412c7.426,7.043,15.99,10.564,25.697,10.564c9.899,0,18.562-3.521,25.981-10.564l185.864-185.864
                                                                c7.043-7.043,10.567-15.701,10.567-25.981C432.54,211.939,429.016,203.37,421.976,196.712z"
                                                              fill="#e45c29"/>
                                                    </svg>
                                                </span>

                                                <span>
                                                    <svg width="14px" height="16px" viewBox="0 0 450 370">
                                                        <path d="M421.976,196.712L236.111,10.848C228.884,3.615,220.219,0,210.131,0c-9.9,0-18.464,3.615-25.697,10.848L163.023,32.26
                                                                c-7.234,6.853-10.85,15.418-10.85,25.697c0,10.277,3.616,18.842,10.85,25.697l83.653,83.937H45.677
                                                                c-9.895,0-17.937,3.568-24.123,10.707s-9.279,15.752-9.279,25.837v36.546c0,10.088,3.094,18.698,9.279,25.837
                                                                s14.228,10.704,24.123,10.704h200.995L163.02,360.88c-7.234,7.228-10.85,15.89-10.85,25.981c0,10.089,3.616,18.75,10.85,25.978
                                                                l21.411,21.412c7.426,7.043,15.99,10.564,25.697,10.564c9.899,0,18.562-3.521,25.981-10.564l185.864-185.864
                                                                c7.043-7.043,10.567-15.701,10.567-25.981C432.54,211.939,429.016,203.37,421.976,196.712z"
                                                              fill="#ffffff"/>
                                                    </svg>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}